import React, { useState } from "react";
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar } from "feather-icons-react";

const DateComponent = ({
  style,
  input_style,
  label,
  name,
  field_name,
  placeholder,
  value,
  onChange,
  required,
  hidden,
  disabled,
  display,
}) => {
  let commonProps = {
    showMonthDropdown: true,
    showYearDropdown: true,
    dropdownMode: "select",
    dateFormat: "dd-MMM-yyyy"
  };
  if (field_name === "exp_date") {
    commonProps = {
      showMonthYearPicker: true,
      dropdownMode: "select",
      dateFormat: "MM-yyyy"
    };
  } else if (field_name === "month_date") {
    commonProps = {
      showMonthYearPicker: true,
      dropdownMode: "select",
      dateFormat: "MMMM-yyyy",
      maxDate: new Date(),
    };
  } else if (field_name === "schedule_time") {
    commonProps = {
      showTimeSelect: true,             // Enable time picker
      timeFormat: "hh:mm a",             // 24-hour format (or "hh:mm aa" for AM/PM)
      timeInterval: 60,             // Time step in minutes
      dropdownMode: "select",
      dateFormat: "dd-MMM-yyyy hh:mm a",
      minDate: new Date(),
    };
  }


  if (hidden) return null;
  //const [selectedDate, setSelectedDate] = useState(null);
  return (
    <>
      {display ? (
        <div className={`${style}`}>
          {label && (
            <label htmlFor={name} className="form-label">
              {required && <span className="text-danger"> * </span>}
              {label}
            </label>
          )}
          <div className="input-group">
            <Calendar className="icon" />
            <DatePicker
              className={`w-full py-2 pr-10 pl-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${input_style}`}
              name={name}
              placeholder={`Enter ${label}`}
              selected={value}
              onChange={onChange}
              required={required}
              disabled={disabled}
              popperPlacement="bottom-start"
              popperModifiers={[
                { name: 'zIndex', enabled: true, phase: 'write', fn: ({ state }) => { state.styles.popper.zIndex = 999999; } }
              ]}
              portalId="root"
              {...commonProps}
            //maxDate={new Date()}
            />
          </div>
        </div>
      ) : (
        <div className={`${style}`}>
          <div className="flex">
            {label !== "" &&
              <div className={`col-md-3`} >
                <label
                  className="form-label"
                  htmlFor={name}
                >
                  {required && <span className="text-danger"> * </span>}{label}
                </label>
              </div>
            }
            <div className={`col-md-5`} >
              <div className="input-group">
                <Calendar className="icon" />
                <DatePicker
                  className={`${input_style}`} // Add right padding
                  name={name}
                  placeholder={`Enter ${label}`}
                  selected={value}
                  onChange={onChange}
                  required={required}
                  disabled={disabled}
                  popperPlacement="bottom-start"
                  popperModifiers={[
                    { name: 'zIndex', enabled: true, phase: 'write', fn: ({ state }) => { state.styles.popper.zIndex = 999999; } }
                  ]}
                  portalId="root"
                  {...commonProps}
                //maxDate={new Date()}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

DateComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  field_name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
};

export default DateComponent;
